import React from "react";
import useAuth from "../hooks/useAuth";
import {
	FAKE_AUTH_STATE,
	IS_LOCAL_DEV,
	disableFakeAuth,
	enableFakeAuth,
	isFakeAuthEnabled
} from "../config/fakeAuth";

/**
 * Interruptor de sesión simulada, solo para desarrollo local.
 *
 * Permite alternar entre la home pública y la de cliente sin tener WordPress
 * corriendo. Escribe el mismo local storage que el login real y actualiza el
 * contexto en el momento, así no hace falta recargar.
 *
 * `IS_LOCAL_DEV` es una constante de build: en producción esto es código muerto
 * que webpack elimina.
 */
const FakeAuthToggle = () => {

	const { auth, setAuth } = useAuth();
	// El primer render (SSR incluido) tiene que coincidir con el HTML del servidor
	const [isMounted, setIsMounted] = React.useState(false);

	React.useEffect(() => setIsMounted(true), []);

	if (!IS_LOCAL_DEV || !isMounted) return null;

	const isEnabled = isFakeAuthEnabled() && Boolean(auth?.user);

	const toggle = () => {
		if (isEnabled) {
			disableFakeAuth();
			setAuth({});
		} else {
			enableFakeAuth();
			setAuth({ ...FAKE_AUTH_STATE });
		}
	};

	return (
		<div className="fixed bottom-4 left-4 z-[9999] flex items-center gap-3 rounded-full border border-white/15 bg-ink/95 py-2 pl-3 pr-4 text-white shadow-lg backdrop-blur">
			<span className="text-[9px] font-bold uppercase tracking-[.11em] text-white/45">Dev</span>

			<button
				type="button"
				onClick={ toggle }
				aria-pressed={ isEnabled }
				title="Simula una sesión iniciada sin backend"
				className="flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[.11em] text-white/85 transition-colors duration-200 hover:text-white"
			>
				<span
					className={ `relative h-4 w-8 flex-none rounded-full transition-colors duration-200 ${isEnabled ? "bg-accent-lime" : "bg-white/25"}` }
					aria-hidden="true"
				>
					<span className={ `absolute top-0.5 h-3 w-3 rounded-full bg-white transition-all duration-200 ${isEnabled ? "left-[18px]" : "left-0.5"}` }></span>
				</span>
				{ isEnabled ? "Sesión: cliente" : "Sesión: pública" }
			</button>
		</div>
	);
};

export default FakeAuthToggle;
